import { render, staticRenderFns } from "./BulkAssignPromo.vue?vue&type=template&id=7b0c5884&scoped=true&"
import script from "./BulkAssignPromo.vue?vue&type=script&lang=js&"
export * from "./BulkAssignPromo.vue?vue&type=script&lang=js&"
import style0 from "./BulkAssignPromo.vue?vue&type=style&index=0&id=7b0c5884&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0c5884",
  null
  
)

export default component.exports